<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Potential"
      title="Potential"
      :logo="logoSrc"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'fa fa-tv text-primary',
            path: '/dashboard'
          }"
        />
        <sidebar-item
          v-if="isOwner"
          :link="{
            name: 'Organizations',
            icon: 'fa fa-city text-primary',
            path: '/organizations'
          }"
        />
        <sidebar-item
          v-if="hasRoles(['userRead']) && curOrg.id != null"
          :link="{
            name: 'Users',
            icon: 'fa fa-users text-primary',
            path: '/users'
          }"
        />
        <sidebar-item
          v-if="curOrg.id != null && curOrg.type === 'employer'"
          :link="{
            name: 'Job Board',
            icon: 'fa fa-briefcase text-primary',
            path: '/jobboard'
          }"
        />
        <sidebar-item
          v-if="curOrg.id != null && (curOrg.type === 'agency' || curOrg.type === 'partner')"
          :link="{
            name: 'Resources',
            icon: 'fa fa-briefcase text-primary',
            path: '/resources'
          }"
        />
        <sidebar-item
          v-if="curOrg.id != null"
          :link="{
            name: curOrg.type === 'employer' ? 'Talent' : 'People',
            icon: 'fa fa-id-card text-primary',
            path: '/potentialees'
          }"
        />
        <sidebar-item
          v-if="curOrg.id != null"
          :link="{
            name: 'Lists',
            icon: 'fa fa-list text-primary',
            path: '/potentialeelists'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Help',
            icon: 'fa fa-question-circle text-primary',
            path: '/help'
          }"
        />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";

import firebase from '../config/firebase.js';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition
  },
  data() {
    return {
      sidebarBackground: "vue" //vue|blue|orange|green|red|primary
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    hasRoles: function(roles) {
      return roles.every(this.hasRole);
    },
    hasRole: function(role) {
      return this.rolesData[role] != null || this.isOwner;
    },
    userData: function() {

      const user = firebase.auth().currentUser;

      this.checkIfOwner(user);

      this.$store.commit("setCurrentUser", user);
    },
    checkIfOwner: function(user) {
      const self = this;

      var ownerRef = firebase
        .firestore()
        .collection("owners")
        .doc(user.uid);

      ownerRef.get().then(function(doc) {
        if (doc.exists) {
          self.$store.commit("setIsOwner", true);
        } else {
          self.checkUserData(user);
        }
      });
    },
    checkUserData: function(user) {
      const self = this;

      var userRef = firebase
        .firestore()
        .collection("users")
        .doc(user.uid);

      userRef.get().then(function(userDoc) {
        if (userDoc.exists) {
          const userData = userDoc.data();

          if (userData.orgId) {
            firebase
              .firestore()
              .doc("organizations/" + userData.orgId)
              .get()
              .then(function(orgDoc) {
                const orgData = orgDoc.data();

                orgData["id"] = orgDoc.id;

                self.$store.commit("setCurOrg", orgData);
              });

            firebase
              .firestore()
              .doc("organizations/" + userData.orgId + "/roles/" + user.uid)
              .get()
              .then(function(rolesDoc) {
                const rolesData = rolesDoc.data();

                self.$store.commit("setRolesData", rolesData);
              });
          }
        }
      });
    }
  },
  computed: {
    logoSrc: () => require("@/assets/logo.svg"),
    curOrg() {
      return this.$store.state.usermain.curOrg;
    },
    currentUser() {
      return this.$store.state.usermain.currentUser;
    },
    isOwner() {
      return this.$store.state.usermain.isOwner;
    },
    rolesData() {
      return this.$store.state.usermain.rolesData;
    }
  },
  watch: {
    currentUser(newCurrentUser, oldCurrentUser) {
      const self = this;

      console.log("NEW CURRENT USER");

      this.checkIfOwner(newCurrentUser);
    }
  },
  mounted() {
    this.userData();
  },
};
</script>
<style lang="scss">
</style>
